import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { LIVES, FOLDERS, SERVICES } from '@bedrock-rdk/constants';
import { removeSplashScreen } from '../../logic/app/app.utils';
import MosaicGrid from '../tornado/templates/blocks/mosaicGrid/mosaicGrid.component';
import connect from './abstractMosaic.connector';
import { SELECTED_SIGNAL } from '../tornado/signals';
import { createItemAction } from '../cta/cta.actions';
import { getInitialStyle, defaultContext } from './abstractMosaic.style';
import { filterNavigationEntries } from './abstractMosaic.utils';
import { ITEM_CONFIG } from './abstarctMosaic.constants';

/**
 * Card is a 16:9 tile component with textual metadata at the bottom of a thumbnail
 *
 * @see https://app.abstract.com/projects/162522cb-a770-4688-9ead-06e1fd627b20/branches/master/collections/8c12ee2f-f69b-487d-ba55-90adeea80936
 */
export class AbstractMosaic extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        Grid: {
          type: MosaicGrid,
          signals: {
            [SELECTED_SIGNAL]: '_handleSelected',
          },
        },
      },
      getInitialStyle(),
    );
  }

  _init() {
    this._style = defaultContext;
  }

  _attach() {
    this._unsubscribe = connect(this);
  }

  _active() {
    removeSplashScreen();
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  set navigation(entries) {
    if (!(entries && this._pageName)) {
      return;
    }

    this.tag('Grid').data = {
      items: filterNavigationEntries(entries, this._pageName),
      itemType: ITEM_CONFIG[this._pageName].item,
      itemSize: ITEM_CONFIG[this._pageName].sizes[this._style.screenSize],
      itemsPerRow: ITEM_CONFIG[this._pageName].itemsPerRow,
    };
  }

  set path(value) {
    if (!value) {
      return;
    }

    this._pageName = [LIVES, FOLDERS, SERVICES].find(item => value.includes(item));
  }

  _handleSelected(item) {
    Store.dispatch(createItemAction({ item: { ...item, action: item } }));
  }

  _getFocused() {
    return this.tag('Grid');
  }
}
